import React from "react";
import "./Step6.css";
import { Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
function Step6({
  next,
  back,
  Institute,
  obstacle,
  annualIntake,
  segmentSuited,
  enrollStudents,
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const nevigate = useNavigate();
  const onSubmit = async (data) => {
  try {
    const payload = {
      ...data,
      segment_suited: segmentSuited,
      enroll_students: enrollStudents,
      annual_intake: annualIntake,
      obstacle: obstacle,
      educational_institute: Institute
    };

    // const response = await axios.post(
    //   `${process.env.REACT_APP_BASE_URL}/profcyma-b2b/form/enquiry`,
    //   payload
    // );

    const crmpayload = {
      
      email: data?.email,
      mobile: data?.contact_no,
      remark: Institute,
      name: data?.full_name,
     api_key :"profcyma-website",
     source_name:"Channel_Partner_B2B"
    };

    const response1 = await axios.post(
      `https://profcymacrm.com/api/landingPage`,
      crmpayload
    );


    nevigate("/registration-done");
  } catch (err) {
    console.error("Submit Error:", err);
  }
};


  return (
    <div className="step6_main">
      <h2 className="step_title">
        Just Answer <span>2</span> Simple questions to become a <br />
        <strong>Profcyma Partner</strong>
      </h2>

      <p className="step_subtitle">Contact Information</p>

      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="form_holder">
          {/* Full Name */}
          <div className="field_holder">
            <Form.Label>Full Name</Form.Label>
            <Form.Control
              placeholder="Enter Name"
              {...register("full_name", { required: "Full name is required" })}
            />
            {errors.full_name && (
              <p className="error_text">{errors.full_name.message}</p>
            )}
          </div>

          {/* Email */}
          <div className="field_holder">
            <Form.Label>Email</Form.Label>
            <Form.Control
              placeholder="Enter Email Id"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/,
                  message: "Enter a valid email",
                },
              })}
            />
            {errors.email && (
              <p className="error_text">{errors.email.message}</p>
            )}
          </div>

          {/* Mobile */}
          <div className="field_holder">
            <Form.Label>Mobile Number</Form.Label>
            <Form.Control
              maxLength={10}
              placeholder="Enter Mobile Number"
              {...register("contact_no", {
                required: "Mobile number is required",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Enter valid 10-digit mobile number",
                },
              })}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault(); // blocks non-numeric input
                }
              }}
            />
            {errors.contact_no && (
              <p className="error_text">{errors.contact_no.message}</p>
            )}
          </div>

          {/* Location */}
          <div className="field_holder">
            <Form.Label>Location (optional)</Form.Label>
            <Form.Control
              placeholder="Select your Town/City"
              {...register("location")}
            />
          </div>
        </div>

        <div className="step_btns">
          <button type="button" onClick={back} className="back_btn">
            Back
          </button>

          <button type="submit" className="next_btn">
            Next
          </button>
        </div>
      </Form>
    </div>
  );
}

export default Step6;
